import { pauseToastDismiss, resumeToastDismiss, useToast } from '@/hooks'
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from './Toast'

interface ToastData {
  id: string
  title?: string
  description?: string
  action?: React.ReactNode
  [key: string]: any
}

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {(toasts as ToastData[]).map(
        ({ id, title, description, action, ...props }) => (
          <Toast
            key={id}
            onMouseEnter={() => pauseToastDismiss(id)}
            onMouseLeave={() => resumeToastDismiss(id)}
            {...props}
          >
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            {/* A clickable toast must not open when the user aims for the X. */}
            <ToastClose onClick={(event) => event.stopPropagation()} />
          </Toast>
        ),
      )}
      <ToastViewport />
    </ToastProvider>
  )
}
